var map = {
	"./Magnifying_glass_icon.png": "e8c6",
	"./close-icon-small.png": "cdaa",
	"./close-icon.png": "b364",
	"./error-icon.png": "056f",
	"./g-logo-transparent.png": "9e3f",
	"./g-logo.png": "08bb",
	"./loading.gif": "f8b2",
	"./logo.png": "4ffd",
	"./logo2.png": "440d",
	"./success-icon.png": "f277",
	"./warning-icon.png": "0f1c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";